module.exports = __webpack_public_path__ + "img/candy5.3eb2afa4.png";